import React from "react";
import Button from "domains/ui/components/Button";
import WithGradientEffect from "domains/ui/components/WithGradientEffect";

import { Flex, Image, Text, VStack } from "@chakra-ui/react";

export default function CanvasListEmptyState() {
  return (
    <Flex data-testid="asset-gallery-empty-state">
      <VStack mt={4}>
        <WithGradientEffect>
          <Image
            w={200}
            h={200}
            alt="Empty state"
            src="/ui/model-empty-state.svg"
          />
        </WithGradientEffect>

        <VStack pt={3} pb={5}>
          <Text size="title.md">No Canvas Available</Text>
        </VStack>

        <Button variant="secondary" internalLink="/canvas/new">
          Start editing now
        </Button>
      </VStack>
    </Flex>
  );
}
